/* eslint-disable */
import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { getCustomerById } from 'service/CustomerService';
import { Typography, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import { colorTheme } from 'theme';
import Avatar from '@mui/material/Avatar';
import { displayEmployeeInfo } from 'service';
import { dateFormat } from 'utils/GeneralUtil';

interface IEmployeeInfo {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  designation: string;
  location: string;
  department: string;
  employeeId: string;
  startDate: string;
  endDate: string;
  profileImage: string;
}

const PersonalDetails = () => {
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);
  const [employeeInfo, setEmployeeInfo] = useState<IEmployeeInfo>();
  const [image, setImage] = useState('');
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      getEmployeeData();
    }
  }, []);

  const getEmployeeData = async () => {
    try {
      const response: any = await displayEmployeeInfo(id as string);
      setEmployeeInfo(response?.details);
      if (response?.details?.profileImage) {
        const profileImgUrl = `${process.env.REACT_APP_MARSHMALLOW_API}api/admin/customer-profile/${response?.details?.profileImage}`;
        setImage(profileImgUrl);
      }
    } catch (error) {}
  };

  const ReuseGrid = (props: any) => {
    return (
      <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', padding: 1 }}>
        <Grid item xs={4} sm={4} md={4}>
          <Typography
            component="h5"
            variant="h5"
            color={'#838383'}
            fontWeight={700}
            fontSize={16}
            fontFamily="Inter !important"
          >
            {props.customName}
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4} md={4}>
          <Typography>:</Typography>
        </Grid>
        <Grid item xs={4} sm={4} md={4}>
          <Typography
            component="h5"
            variant="h5"
            color={colors.gray[100]}
            fontWeight={700}
            fontSize={16}
            fontFamily="Inter !important"
          >
            {props.customerDetails}
          </Typography>
        </Grid>
      </Grid>
    );
  };
  return (
    <Box>
      <Paper
        sx={{
          margin: 'auto',
          flexGrow: 1,
        }}
      >
        <Grid container item xs={12} sm={12} md={12}>
          <Grid item xs={3} sm={3} md={3}>
            <Box
              sx={{
                padding: 2,
              }}
            >
              <Typography
                component="h5"
                variant="h5"
                color={colors.greenAccent[500]}
                fontWeight={800}
                fontSize={18}
                fontFamily={'Inter !important'}
                sx={{
                  textAlign: 'center',
                  marginBlock: 2,
                }}
              >
                Profile picture
              </Typography>
              <Box marginBottom={5}></Box>
              <Box
                sx={{
                  alignSelf: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                {employeeInfo?.profileImage && employeeInfo?.profileImage ? (
                  <Avatar
                    sx={{
                      height: '100px',
                      width: '100px',
                      alignSelf: 'center',
                      bgcolor: '#e4dfed',
                      color: '#202020',
                      fontWeight: 700,
                      fontSize: 40,
                    }}
                    alt="img"
                    src={image}
                  />
                ) : (
                  <Avatar
                    sx={{
                      width: '100px',
                      height: '100px',
                      alignSelf: 'center',
                      bgcolor: '#B5DFC8',
                      color: '#202020',
                      fontFamily: 'Inter',
                      fontWeight: 700,
                      fontSize: 40,
                    }}
                  >
                    {employeeInfo?.firstName &&
                      employeeInfo?.firstName.slice(0, 1) +
                        employeeInfo?.lastName.slice(0, 1)}
                  </Avatar>
                )}
              </Box>
            </Box>
          </Grid>

          <Grid item xs={8} sm={8} md={8} sx={{ marginBlock: 2 }}>
            <Box marginTop={1}></Box>
            <ReuseGrid
              customName={'Full name'}
              customerDetails={
                employeeInfo?.firstName
                  ? employeeInfo?.firstName + ' ' + employeeInfo?.lastName
                  : '-'
              }
            />
            <ReuseGrid
              customName={'Email address'}
              customerDetails={employeeInfo?.email ? employeeInfo?.email : '-'}
            />
            <ReuseGrid
              customName={'Phone number'}
              customerDetails={employeeInfo?.phone}
            />
            <Divider sx={{ marginBlock: 2 }} />
            <ReuseGrid
              customName={'Designation/Role'}
              customerDetails={
                employeeInfo?.designation ? employeeInfo?.designation : '-'
              }
            />
            <ReuseGrid
              customName={'Department'}
              customerDetails={
                employeeInfo?.department ? employeeInfo?.department : '-'
              }
            />
            <ReuseGrid
              customName={'Location'}
              customerDetails={
                employeeInfo?.location ? employeeInfo?.location : '-'
              }
            />
            <ReuseGrid
              customName={'Employee ID'}
              customerDetails={
                employeeInfo?.employeeId ? employeeInfo?.employeeId : '-'
              }
            />

            <Divider sx={{ marginBlock: 2 }} />
            <ReuseGrid
              customName={'Start Date'}
              customerDetails={
                employeeInfo?.startDate
                  ? dateFormat(employeeInfo?.startDate)
                  : '-'
              }
            />
            <ReuseGrid
              customName={'End Date'}
              customerDetails={
                employeeInfo?.endDate ? employeeInfo?.endDate : '-'
              }
            />
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default PersonalDetails;
